import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  loadMembers,
  saveMembers,
  deleteMembers,
  clearAjaxCall,
  loadExportMembers
} from '../actions/Members'
import { loadCourses } from '../actions/Courses'

import DualRing from './DualRing'
import AjaxSpinner from './AjaxSpinner'
import Error from './Error'

import MemberDetails from './Members/MemberDetails'
import EditMember from './Members/EditMember'
import DeleteMember from './Members/DeleteMember'
import { memberTypes, sexTypes, tshirtSizes } from '../options.json'

import { grant } from './Utils/Service'

const initialState = {
  showDelete: false,
  showEdit: false,
  member: {},
  search: '',
  search_member_type: '',
  search_sex_type: '',
  search_tshirt_size: '',
  search_course: '',
  expanded: false
}

class Members extends Component {
  constructor(props) {
    super(props)
    this.showDelete = this.showDelete.bind(this)
    this.showEdit = this.showEdit.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.state = initialState
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.hideModal()
    }
  }
  componentWillMount() {
    if (this.props.members.list === null) {
      this.props.loadMembers()
    }
    if (this.props.courses.list === null) {
      this.props.loadCourses()
    }
  }
  showDelete(member) {
    this.setState({ showDelete: true, member })
  }
  showEdit(member) {
    this.setState({ showEdit: true, member })
  }
  newMember() {
    this.setState({
      showEdit: true,
      member: {
        id: null,
        name: '',
        surname: '',
        sex: '',
        email: '',
        postal_code: '',
        city: '',
        address: '',
        country: '',
        born_date: '',
        age: '',
        born_city: '',
        born_country: '',
        fiscal_code: '',
        tutor_id: '',
        tshirt_size: '',
        phone: '',
        mobile: '',
        notes: '',
        course_id: '',
        insurance_date: '',
        medical_certificate: '',
        medical_certificate_doc: '',
        doc_name: '',
        medical_certificate_checksum: '',
        title: ''
      }
    })
  }
  hideModal() {
    this.setState({
      showDelete: false,
      showEdit: false
    })
  }
  reloadmembers() {
    this.props.loadMembers()
  }
  expand() {
    this.setState({ expanded: !this.state.expanded })
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.members.ajaxSpinner &&
      !this.props.members.ajaxSpinner &&
      this.props.members.ajaxStatus === null
    ) {
      this.hideModal()
    }
    if (
      prevProps.members.ajaxSpinner &&
      !this.props.members.ajaxSpinner &&
      this.props.members.ajaxStatus !== null
    ) {
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    }
  }
  filterList(list) {
    if (list === null) {
      return null
    }
    return list
      .filter((item) => {
        return this.state.search_member_type === ''
          ? true
          : item.active.toString() === this.state.search_member_type
      })
      .filter((item) => {
        return this.state.search_sex_type === ''
          ? true
          : item.sex === this.state.search_sex_type
      })
      .filter((item) => {
        return this.state.search_tshirt_size === ''
          ? true
          : item.tshirt_size === this.state.search_tshirt_size
      })
      .filter((item) => {
        return this.state.search_course === ''
          ? true
          : item.course_id.toString() === this.state.search_course
      })
      .filter(
        (el) =>
          el.name_surname
            .toLowerCase()
            .indexOf(this.state.search.toLowerCase()) >= 0 ||
          el.email.toLowerCase().indexOf(this.state.search.toLowerCase()) >=
            0 ||
          el.fiscal_code
            .toLowerCase()
            .indexOf(this.state.search.toLowerCase()) >= 0
      )
  }
  export() {
    const s = this.state
    this.props.loadExportMembers({
      search: s.search,
      search_member_type: s.search_member_type,
      search_sex_type: s.search_sex_type,
      search_tshirt_size: s.search_tshirt_size,
      search_course: s.search_course
    })
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  render() {
    const { list, error, loading, ajaxSpinner, uploading } = this.props.members
    const filteredList = this.filterList(list)
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Anagrafiche</div>
          <div className='ph-descr'>
            <ul className='ul-filter'>
              <li>
                <input
                  type='text'
                  placeholder='Cerca anagrafiche'
                  onChange={(event) =>
                    this.setState({ search: event.target.value })
                  }
                  value={this.state.search}
                />
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_member_type: event.target.value })
                  }
                  value={this.state.search_member_type}
                >
                  {memberTypes.map((o, index) => {
                    return (
                      <option key={index} value={o.value}>
                        {o.label}
                      </option>
                    )
                  })}
                </select>
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_sex_type: event.target.value })
                  }
                  value={this.state.search_sex_type}
                >
                  {sexTypes
                    .filter((item) => {
                      return item.search || item.search === undefined
                    })
                    .map((o, index) => {
                      return (
                        <option key={index} value={o.value}>
                          {o.label}
                        </option>
                      )
                    })}
                </select>
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_tshirt_size: event.target.value })
                  }
                  value={this.state.search_tshirt_size}
                >
                  {tshirtSizes
                    .filter((item) => {
                      return item.search || item.search === undefined
                    })
                    .map((o, index) => {
                      return (
                        <option key={index} value={o.value}>
                          {o.label}
                        </option>
                      )
                    })}
                </select>
              </li>
              <li>
                <select
                  onChange={(event) =>
                    this.setState({ search_course: event.target.value })
                  }
                  value={this.state.search_course}
                >
                  <option value=''>Tutti i corsi</option>
                  {this.props.courses.list !== null &&
                    this.props.courses.list.map((o, index) => {
                      return (
                        <option key={index} value={o.id}>
                          {o.name}
                        </option>
                      )
                    })}
                </select>
              </li>
            </ul>
          </div>
          <ul className='ph-btn'>
            {/* {
              grant() && (
                <li><button onClick={() => this.export()} className="lnk-tools"><i className="fas fa-file-export"></i> esporta</button></li>
              )
            } */}
            <li>
              <button onClick={() => this.export()} className='lnk-tools'>
                <i className='fas fa-file-export'></i> esporta
              </button>
            </li>
            <li>
              <button onClick={() => this.expand()} className='lnk-tools'>
                <i className='fas fa-info-circle'></i>{' '}
                {this.state.expanded ? 'Nascondi' : 'Visualizza'} dettagli
              </button>
            </li>
            {grant() && (
              <li>
                <button onClick={() => this.newMember()} className='lnk-tools'>
                  <i className='fas fa-user-plus'></i> aggiungi
                </button>
              </li>
            )}
            <li>
              <button
                onClick={() => this.reloadmembers()}
                className='lnk-tools'
              >
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          <div className='ph-count'>
            {filteredList !== null &&
              filteredList.length +
                (filteredList.length === 1 ? ' risultato' : ' risultati')}
            {filteredList === null && <i className='fas fa-sync fa-spin'></i>}
          </div>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        {list !== null &&
          filteredList
            .sort((a, b) => {
              return a.surname > b.surname ? 1 : b.surname > a.surname ? -1 : 0
            })
            .map((m, index) => {
              return (
                <MemberDetails
                  key={index}
                  member={m}
                  expanded={this.state.expanded}
                  showDelete={this.showDelete}
                  showEdit={this.showEdit}
                />
              )
            })}
        {this.state.showEdit && (
          <EditMember member={this.state.member} hideModal={this.hideModal} />
        )}
        {this.state.showDelete && (
          <DeleteMember member={this.state.member} hideModal={this.hideModal} />
        )}
        {(ajaxSpinner || uploading) && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadMembers,
  saveMembers,
  deleteMembers,
  loadCourses,
  clearAjaxCall,
  loadExportMembers
})(Members)



// WEBPACK FOOTER //
// ./src/components/Members.js